module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAAz0lEQVRYR+2WMQoCMRBFM7qK6QSF2C2rjXgHz+c9PEFukMIb7IKTJs12wVLZRjCiR8gEllkm/Z9k3kuYgPfeGWPWiuFCxA6GYUCt9ZHh+VWM0UoDY5oTA2PS/+0tBsQAkcA0rhBi78xuy3IS3zG0sD9dEGDBchKr9LLSAPEd0uJigMaPnhYDdIa0CmKAxo+enoSB6+Hslp85y6/Ec/ZuIdQ1rpRi+ZV4AFhpgP4S8yuIgXx2ZZJioAzH/CpiIJ9dmeTfwK1p3CYllpM4VFX3BU8Oqnj6swgLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c164.png
// module id = Jn2k
// module chunks = 18